import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tMeasurement Types\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add Measurement Type", -1 /* HOISTED */);
const _hoisted_8 = { class: "form-contents" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "clearfix" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_12 = { class: "input-group top_search" };
const _hoisted_13 = { class: "input-group-btn" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = { class: "col-xs-12 col-sm-12" };
const _hoisted_17 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_18 = { class: "table table-hover bottom0 pw100" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\tMeasurement\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\tComponent\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\tCategory\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, [
            /*#__PURE__*/ _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tUoM"),
            /*#__PURE__*/ _createElementVNode("br"),
            /*#__PURE__*/ _createTextVNode("(Metric)\r\n\t\t\t\t\t\t\t\t\t")
        ]),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, [
            /*#__PURE__*/ _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tUoM"),
            /*#__PURE__*/ _createElementVNode("br"),
            /*#__PURE__*/ _createTextVNode("(Imperial)\r\n\t\t\t\t\t\t\t\t\t")
        ]),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, [
            /*#__PURE__*/ _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tUoM Code"),
            /*#__PURE__*/ _createElementVNode("br"),
            /*#__PURE__*/ _createTextVNode("(Metric)\r\n\t\t\t\t\t\t\t\t\t")
        ]),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, [
            /*#__PURE__*/ _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tUoM Code"),
            /*#__PURE__*/ _createElementVNode("br"),
            /*#__PURE__*/ _createTextVNode("(Imperial)\r\n\t\t\t\t\t\t\t\t\t")
        ]),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "\r\n\t\t\t\t\t\t\t\t\t\tMetric to Imperial Multiplier\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "\r\n\t\t\t\t\t\t\t\t\t\tMetric to Imperial Sum Factor\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "w100" })
    ])
], -1 /* HOISTED */);
const _hoisted_20 = { class: "min-width300" };
const _hoisted_21 = { class: "invalid-feedback" };
const _hoisted_22 = { class: "min-width100" };
const _hoisted_23 = { class: "min-width100" };
const _hoisted_24 = { class: "min-width150" };
const _hoisted_25 = { class: "invalid-feedback" };
const _hoisted_26 = { class: "min-width150" };
const _hoisted_27 = { class: "w50 min-width50" };
const _hoisted_28 = { class: "invalid-feedback" };
const _hoisted_29 = { class: "w50 min-width50" };
const _hoisted_30 = { class: "w50 min-width50 text-end" };
const _hoisted_31 = { class: "w50 min-width50 text-end" };
const _hoisted_32 = { class: "min-width100 text-end" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_35 = { key: 0 };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", {
        class: "text-center",
        colspan: "10"
    }, [
        /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_37 = [
    _hoisted_36
];
const _hoisted_38 = { class: "data-grid-footer clearfix detached pw100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_select = _resolveComponent("b-form-select");
    const _component_b_pagination = _resolveComponent("b-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _ctx.add
                    }, {
                        default: _withCtx(() => [
                            _hoisted_6,
                            _hoisted_7
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_13, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, _hoisted_15)
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("table", _hoisted_18, [
                            _hoisted_19,
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_20, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.measurementTypeName,
                                                "onUpdate:modelValue": ($event) => ((item.measurementTypeName) = $event),
                                                modelModifiers: { trim: true },
                                                class: _normalizeClass({ 'is-invalid': !item.measurementTypeName }),
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_21, "\r\n\t\t\t\t\t\t\t\t\t\t\tThe Measurement Type field is required.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, !item.measurementTypeName]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_22, [
                                            _createVNode(_component_b_form_select, {
                                                modelValue: item.componentTypeId,
                                                "onUpdate:modelValue": ($event) => ((item.componentTypeId) = $event),
                                                options: _ctx.componentTypes
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_23, [
                                            _createVNode(_component_b_form_select, {
                                                modelValue: item.measurementCategoryId,
                                                "onUpdate:modelValue": ($event) => ((item.measurementCategoryId) = $event),
                                                options: _ctx.measurementCategories
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_24, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.unitOfMeasurement,
                                                "onUpdate:modelValue": ($event) => ((item.unitOfMeasurement) = $event),
                                                modelModifiers: { trim: true },
                                                class: _normalizeClass({ 'is-invalid': !item.unitOfMeasurement }),
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_25, "\r\n\t\t\t\t\t\t\t\t\t\t\tThe Unit of Measurement field is required.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, !item.unitOfMeasurement]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_26, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.unitOfMeasurementImperial,
                                                "onUpdate:modelValue": ($event) => ((item.unitOfMeasurementImperial) = $event),
                                                modelModifiers: { trim: true },
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_27, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.unitOfMeasurementCode,
                                                "onUpdate:modelValue": ($event) => ((item.unitOfMeasurementCode) = $event),
                                                modelModifiers: { trim: true },
                                                class: _normalizeClass({ 'is-invalid': !item.unitOfMeasurementCode }),
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_28, "\r\n\t\t\t\t\t\t\t\t\t\t\tThe Unit of Measurement Code field is required.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, !item.unitOfMeasurementCode]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_29, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.unitOfMeasurementCodeImperial,
                                                "onUpdate:modelValue": ($event) => ((item.unitOfMeasurementCodeImperial) = $event),
                                                modelModifiers: { trim: true },
                                                maxlength: "150"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_30, [
                                            _createVNode(_component_b_form_input, {
                                                type: "number",
                                                modelValue: item.conversionFactor,
                                                "onUpdate:modelValue": ($event) => ((item.conversionFactor) = $event),
                                                modelModifiers: { trim: true },
                                                maxlength: "10"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_31, [
                                            _createVNode(_component_b_form_input, {
                                                type: "number",
                                                modelValue: item.conversionAdditionalFactor,
                                                "onUpdate:modelValue": ($event) => ((item.conversionAdditionalFactor) = $event),
                                                modelModifiers: { trim: true },
                                                maxlength: "10"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_32, [
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: ($event) => (_ctx.save(item))
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_33
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: ($event) => (_ctx.purge(item))
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_34
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                        ])
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_35, _hoisted_37))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_b_pagination, {
                            class: "float-end",
                            modelValue: _ctx.query.pageNo,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.pageNo) = $event)),
                            "per-page": _ctx.query.pageSize,
                            "total-rows": _ctx.data.recordCount,
                            "hide-ellipsis": true,
                            disabled: _ctx.working
                        }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
